import React from 'react';
import styled from '@emotion/styled';
import { PartnerType } from '../../../../types/benefit';

interface ColumnProps {
  record: PartnerType;
}

export default React.memo((props: ColumnProps) => {
  const { record } = props;

  return (
    <StyledPartnerContainer>
      {record.partnerBrandImageUrl ? (
        <img className="image" src={record.partnerBrandImageUrl} alt="" />
      ) : (
        <div className="image" />
      )}
    </StyledPartnerContainer>
  );
});

const StyledPartnerContainer = styled.div`
  display: flex;
  align-items: center;
  padding-left: 0.5rem;
  .image {
    width: auto;
    max-height: 3.2rem;
    background-color: #eee;
    background-size: cover;
    background-position: center center;
    border: 1px solid #eee;
    margin-right: 0.5rem;
  }
  span {
    font-weight: 600;
  }
  button {
    position: absolute;
    right: 0;
  }
  text-align: left;
  justify-content: center;

  .ant-typography {
    width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-height: 21px;
    max-height: 48px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
`;
